<!-- <head>
  <meta property="og:title" :content="news.headannounces" />
  <meta property="og:image" :content="news.imagesurl" />
  <meta property="og:url" :content="url_test" />
  <meta property="og:description" :content="news.companyname"/>
</head> -->
<template>
<!--   <div> -->
<!-- http://strd6.com/2011/09/html5-javascript-pasting-image-data-in-chrome/ -->

<div class="container fluid" style="overflow-y: scroll;height: 60vh;">
<!--  <video id=example-video width=960 height=540 class="video-js vjs-default-skin" controls>
  <source
     src="https://d2zihajmogu5jn.cloudfront.net/bipbop-advanced/bipbop_16x9_variant.m3u8"
     type="application/x-mpegURL" :withCredentials=true />
</video> -->
<vplayer :playerOptions="{
        type: 'application/x-mpegURL',//媒体类型，m3u8请给application/x-mpegURL或者application/vnd.apple.mpegURL，其他的会默认为普通音视频，注：微信不支持m3u8
        src: url_test,//视频地址
        preload: true,//是否预下载，默认为true
        autoplay: false,//是否自动播放（兼容性不太好），默认为false
        isLoop: false,//是否循环，默认不循环
        playsinline: false, //h5是否行内播放，默认false，有兼容性问题
        poster: 'https://oimdztrab.qnssl.com/Frp4SyVe5PosdkUKRaE-krjK7B5z',
        controls: 'progress,current,durration,volume', //显示的控件,volume只有视频有，没有配置controls项则全部显示。
        crossOrigin: false //设置视频的 CORS 设置。
      }" @onplay="play" />

</div>
</template>


<script>
import { vplayer } from 'vue-hls-player'
export default {
  data() {
    return {
      // url_test: 'https://bitmovin-a.akamaihd.net/content/playhouse-vr/m3u8s/105560.m3u8'
      // url_test: 'http://localhost:8081/bachgavotteshort/outputlist.m3u8'
      // url_test: 'http://203.150.34.140:3000/video/4guTPD_QBS9aOZwdwyd_z/output.m3u8'
      url_test: 'https://player.onenews.sdi.one.th/live/test.m3u8'
      // url_test: 'https://chat-api.one.th/alpine/api/v1/file/XlTZWHDZaMUba7cb86c384f5fa5b3eae7269b4993ce_2021-01-26_11:37:51:850753.mp4'
    }
  },
  created () {
  },
  components: { vplayer },
  methods:{
    play (e) {
      console.log(e)
    }
  }
}
</script>
<style scoped>
.target {
  border: solid 1px #aaa;
  min-height: 200px;
  width: 30%;
  margin-top: 1em;
  border-radius: 5px;
  cursor: pointer;
  transition: 300ms all;
  position: relative;
}

.contain {
  background-size: cover;
  position: relative;
  z-index: 10;
  top: 0px;
  left: 0px;
}

textarea {
  background-color: white;
}

.active {
  box-shadow: 0px 0px 10px 10px rgba(0, 0, 255, .4);
}

>>>.trix-button-group--file-tools {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/test3.vue